import { addTrack } from 'root/src/client/logic/analytics/pixel/facebookPixel';
import { gaSendEvent } from 'root/src/client/logic/analytics/googleAnalytics';
import tiktokPixelTrackEvent from '../events/tiktokPixelTrackEvent';
export default function analyticsSendItem(eventName, label, value) {
    if (value && value > 0)
        addTrack('Purchase', { value, currency: 'USD' });
    tiktokPixelTrackEvent(eventName, label);
    gaSendEvent(value, eventName, label);
}
